import brandData from "@brand/theme.json";
import type { BrandTokens } from "@fprint/ui";

export const brand: BrandTokens = brandData;
